import $ from 'jquery'

const add_view_more = () => {
    if ($('.list-cap').length !== 0) {
        if($(window).innerWidth() < 480) {
            if($('.view-more-btn').length === 0) {
                const button = $('<button>').addClass('view-more-btn').text('View More');
                $('.about-container_content ul').after(button);
                button.on('click', () => {
                    if (button.text() === 'View More') {
                        button.text('Show Less');
                        $('.list-cap').addClass('remove-cap');
                    } else {
                        button.text('View More');
                        $('.list-cap').removeClass('remove-cap');
                    }
                });
            }
        }
    }
}

$(window).on('resize load', ()=> {
    add_view_more()
})